/**
 * Address model
 * ---
 * @type {{
 *  country: string,
 *  phoneNumber: string,
 *  city: string,
 *  street: string,
 *  postalCode: string,
 *  latitude: number,
 *  houseNumber: string,
 *  floor: string,
 *  email: string,
 *  url: string,
 *  longitude: number
 * }}
 */
import { E_LocationStorage_Block_Type, E_LocationStorage_Frame_Side, E_LocationStorage_Frame_Type } from "./constants/Enums_Location";

export const M_Address = {
	street: null,
	houseNumber: null,
	floor: null,
	postalCode: null,
	city: null,
	country: null,
	phoneNumber: null,
	email: null,
	url: null,
	latitude: null,
	longitude: null,
};

export const M_StorageService = {
	enabled: true,
	physicalReference: '',
	serviceType: '',
	occupied: false,
	activeSession: {},
};

/**
 * Storage block model
 * @type {{
 *  service: M_StorageService,
 *  blockType: E_LocationStorage_Block_Type
 * }}
 */
export const M_StorageBlock = {
	blockType: E_LocationStorage_Block_Type.SINGLE,
	service: M_StorageService,
};

/**
 * Storage frame model
 * ---
 * @type {{
 *  side: E_LocationStorage_Frame_Side,
 *  blocks: M_StorageBlock[],
 *  frameType: E_LocationStorage_Frame_Type
 * }}
 */
export const M_StorageFrame = {
	frameType: E_LocationStorage_Frame_Type.BIKE_BOX,
	blocks: [],
	side: E_LocationStorage_Frame_Side.FRONT,
};

/**
 * Storage unit model
 * ---
 * @type {{
 *  name: string,
 *  frames: M_StorageFrame[],
 *  locationIdentifier: number
 * }}
 */
export const M_StorageUnit = {
	name: null,
	frames: [],
	locationIdentifier: null,
};

/**
 * Location model
 * ---
 * @type {{
 *  name: string,
 *  address: M_Address,
 *  storageUnits: M_StorageUnit[]
 * }}
 */
export const M_Location = {
	name: null,
	storageUnits: [],
	address: M_Address,
};
